<template>
  <b-container>
    <div>
      <div class="mb-5 d-flex">
        <Breadcrumbs />
        <router-link :to="currentRouteLink" class="ml-2 not-active">
          {{ currentRouteLabel }}
        </router-link>
      </div>
      <b-row class="mb-5 ml-0" align-h="between">
        <b-col cols="12" sm="4" class="mt-4 ml-n3">
          <h4 class="text-left text-primary">Explore Projects</h4>
        </b-col>
        <b-col
          cols="12"
          sm="3"
          class="text-right mt-n1 mr-n2 ml-n3 ml-sm-auto pl-4 justify-content-end d-flex"
        >
          <base-input
            v-model="search"
            prepend="fa fa-search"
            prependclass="mt-1"
            :filled="true"
            placeholder="Search"
            style="width: 196.5px; margin-left: 1rem"
          />
        </b-col>
      </b-row>
      <b-row class="p-0" no-gutters align-h="between">
        <b-col cols="12" sm="9">
          <div v-if="loading" class="text-center loading-icon">
            <b-spinner v-if="loading" x-large />
          </div>
          <div v-else>
            <ProjectCard
              v-for="(project, index) in ComputedProjects"
              :key="index"
              :to="`/inventory/project/${project.id}`"
              :seemorelink="false"
              :date="project.created_at"
            >
              <template slot="body">
                <b-card-title class="text-left font-weight-bold text-black-50 h5">
                  {{ project.name }}
                </b-card-title>
                <b-card-text class="text-left text-black-50">
                  Capacity building for Local Governments and States' Ministries, Departments and
                  Agencies (MDAs) responsible for rural water supply and sanitation intervention.
                </b-card-text>

                <div class="text-left mt-4">
                  <span class="font-weight-bolder text-black-50">Period of Implementation:</span>
                  <span class="ml-1 text-black-50">
                    {{ getYear(project.start_date) }} - {{ getYear(project.end_date) }}
                  </span>
                </div>

                <div class="text-left mt-4">
                  <span class="font-weight-bolder text-black-50">Programs Area:</span>
                  <span
                    v-for="(program, programIndex) in project.program_area"
                    :key="programIndex"
                    class="ml-1 text-primary text-decoration-none"
                  >
                    <span v-if="programIndex !== project.program_area.length - 1">
                      {{ getProgramAreaName(program) }},
                    </span>
                    <span v-else>{{ program }}</span>
                  </span>
                </div>
              </template>
            </ProjectCard>
            <div class="d-flex justify-content-center align-items-center mt-4">
              <p class="mt-1 mx-2">Row per page</p>
              <select id="zone" v-model="perPage" style="width: 50px; height: 40px">
                <option value="3">3</option>
                <option value="5">5</option>
                <option value="10">10</option>
              </select>
              <p class="mx-3 mx-4 h5">
                <span>Page </span>{{ currentPage }} of
                {{ Math.ceil(computedData.length / perPage) }}
              </p>
              <b-pagination
                v-model="currentPage"
                :total-rows="computedData.length"
                :per-page="perPage"
                aria-controls="my-table"
              />
            </div>
          </div>
        </b-col>
        <b-col cols="3" class="d-none d-sm-block" style="padding-left: 77px">
          <FilterSideBar @filterObjs="fetchDataBasedOnSelectedRequirements" />
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions, mapState } from 'vuex';
import ProjectCard from '../../components/Shared/ProjectCard.vue';
import FilterSideBar from '../../components/Shared/FilterSideBar.vue';
import Breadcrumbs from '../../components/Shared/Breadcrumbs.vue';

export default {
  components: {
    ProjectCard,
    FilterSideBar,
    Breadcrumbs,
  },
  data() {
    return {
      currentPage: 1,
      total: 0,
      perPage: 3,
      currentRouteLabel: '',
      breadcrumb: {
        breadcrumbLink: '',
        breadcrumbLabel: '',
      },
      currentRouteLink: '',
      loading: false,
      projects: { results: [] },
      search: '',
      tempProjects: '',
    };
  },
  computed: {
    ...mapGetters('DATASET_STORE', ['getFilterData']),
    ...mapGetters('auth', ['user']),
    ...mapState('DATASET_STORE', ['breadCrumbData']),
    computedData() {
      return this.projects.filter((project) =>
        project.name.toLowerCase().match(this.search.toLowerCase())
      );
    },
    ComputedProjects() {
      return this.computedData.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
  },
  watch: {
    search() {
      this.currentPage = 1;
    },
    getFilterData(val) {
      this.loading = true;

      val.status.forEach((pro) => {
        this.projects = this.tempProjects.filter((proj) => proj.status.value === pro);
      });

      this.loading = false;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let previousRouteLabel = '';
      let previousRouteLink = '';

      if (from.path === '/inventory/project') {
        previousRouteLabel = 'Project Inventory';
        previousRouteLink = from.path;
      }
      if (from.path === '/') {
        previousRouteLabel = 'Home';
        previousRouteLink = from.path;
      }
      if (from.path === '/inventory/project-inventory') {
        previousRouteLabel = 'Explore Projects';
        previousRouteLink = from.path;
      }
      if (from.path === '/inventory/submit-project') {
        previousRouteLabel = 'Submit Project';
        previousRouteLink = from.path;
      }
      if (from.path === '/inventory/dataset') {
        previousRouteLabel = 'Dataset Inventory';
        previousRouteLink = from.path;
      }
      if (from.path === '/inventory/dataset-inventory') {
        previousRouteLabel = 'Explore Datasets';
        previousRouteLink = from.path;
      }
      if (from.path === '/inventory/submit-dataset') {
        previousRouteLabel = 'Submit Datasets';
        previousRouteLink = from.path;
      }

      const breadcrumb = {
        breadcrumbLabel: previousRouteLabel,
        breadcrumbLink: previousRouteLink,
      };

      if (vm.breadCrumbData) {
        let itemExists = false;

        vm.breadCrumbData.forEach((item) => {
          if (item.breadcrumbLabel === breadcrumb.breadcrumbLabel) {
            itemExists = true;
          }
        });

        if (!itemExists) {
          vm.PUSHBREADCRUMB(breadcrumb);
        }
      }
    });
  },
  mounted() {
    this.fetchData();
    this.getRoute();
  },
  methods: {
    ...mapActions('DATASET_STORE', ['PUSHBREADCRUMB']),
    async fetchData() {
      this.loading = true;

      try {
        const projects = await this.$dataset.getAllProjects();
        this.projects = projects.data.results;
        this.tempProjects = this.projects;
        this.total = projects.data.count;
      } finally {
        this.loading = false;
      }
    },
    getRoute() {
      if (this.$route.path === '/inventory/project') {
        this.currentRouteLink = this.$route.path;
        this.currentRouteLabel = 'Project Inventory';
      }
      if (this.$route.path === '/') {
        this.currentRouteLink = this.$route.path;
        this.currentRouteLabel = 'Home';
      }
      if (this.$route.path === '/inventory/project-inventory') {
        this.currentRouteLink = this.$route.path;
        this.currentRouteLabel = 'Explore Projects';
      }
      if (this.$route.path === '/inventory/submit-project') {
        this.currentRouteLink = this.$route.path;
        this.currentRouteLabel = 'Submit Project';
      }
      if (this.$route.path === '/inventory/dataset') {
        this.currentRouteLink = this.$route.path;
        this.currentRouteLabel = 'Dataset Inventory';
      }
      if (this.$route.path === '/inventory/dataset-inventory') {
        this.currentRouteLink = this.$route.path;
        this.currentRouteLabel = 'Explore Datasets';
      }
      if (this.$route.path === '/inventory/submit-dataset') {
        this.currentRouteLink = this.$route.path;
        this.currentRouteLabel = 'Submit Datasets';
      }
    },
    async getProgramAreaName(programAreaId) {
      const programArea = await this.$dataset.getSpecificProgramArea(programAreaId);
      return programArea.data.name;
    },
    async fetchDataBasedOnSelectedRequirements(data) {
      this.currentPage = 1;
      this.loading = true;

      try {
        const filtered = await this.$dataset.filteredData(data);
        this.projects = filtered.data;
        this.total = filtered.data.length;
      } finally {
        this.loading = false;
      }
    },
    getYear(date) {
      return moment(date).format('YYYY');
    },
  },
};
</script>

<style>
.not-active {
  color: gray;
}
</style>
